import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "plan-header flex-md-row flex-column align-items-start align-items-md-center sm-gap-10"
}
const _hoisted_2 = { class: "plan-breadcrumbs" }
const _hoisted_3 = { class: "plan-breadcrumbs-left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "plan-modal" }
const _hoisted_6 = {
  key: 2,
  class: "active pdl-10"
}
const _hoisted_7 = { class: "plan-switch" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-close" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "modal-overlay success-modal-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['plan', { [_ctx.classNames]: true, [_ctx.modalType]: true, 'active': _ctx.isVisible, 'slide-out': !_ctx.isVisible && _ctx.modalType !== 'slide-out' }]),
      style: _normalizeStyle(_ctx.modalStyles),
      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClickOutside && _ctx.handleClickOutside(...args)), ["self"]))
    }, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("i", {
                  class: "iatse-icon-left-arrow close-plan-modal",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }),
                (!_ctx.secondTitle)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.title), 1))
                  : (_openBlock(), _createElementBlock("h3", {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                    }, [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.title), 1)
                    ])),
                (_ctx.secondTitle)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_6, " > " + _toDisplayString(_ctx.secondTitle), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "steps"),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerButtons, (button, index) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: index,
                    href: "#",
                    class: _normalizeClass(['btn plan-modal hide-mobile', { 'btn-primary': button?.type === 'primary', 'btn-secondary': button?.type === 'secondary' }]),
                    onClick: _withModifiers(($event: any) => (_ctx.handleButtonModal(button)), ["prevent"])
                  }, _toDisplayString(button.name), 11, _hoisted_8))
                }), 128)),
                _createElementVNode("div", {
                  class: "close-btn close-plan-modal",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_10)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerButtons, (button, index) => {
              return (_openBlock(), _createElementBlock("a", {
                key: index,
                href: "#",
                class: _normalizeClass(['btn plan-modal hide-desktop w-sm-100', { 'btn-primary': button?.type === 'primary', 'btn-secondary': button?.type === 'secondary' }]),
                onClick: _withModifiers(($event: any) => (_ctx.handleButtonModal(button)), ["prevent"])
              }, _toDisplayString(button.name), 11, _hoisted_11))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getModalContent(_ctx.modalType)), {
        onClose: _ctx.closeModal,
        onCloseAbove: _ctx.closeAbove,
        onHandleSubmit: _ctx.handleSubmit,
        onToggleHeaderButton: _ctx.toggleHeaderButton,
        fund: _ctx.fund,
        modalProps: _ctx.modalProps,
        index: _ctx.index
      }, null, 40, ["onClose", "onCloseAbove", "onHandleSubmit", "onToggleHeaderButton", "fund", "modalProps", "index"]))
    ], 6),
    (_ctx.modalType === 'success-modal')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12))
      : _createCommentVNode("", true),
    (_ctx.modalType === 'smartsearch')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeOnOutsideClick && _ctx.closeOnOutsideClick(...args)), ["self"])),
          class: "modal-overlay success-modal-overlay smartsearch"
        }))
      : _createCommentVNode("", true)
  ], 64))
}